import apiFetech from "../configs/axios";
import {
  API_PROFILE_URL,
  API_SIGNIN_URL,
  API_SIGNUP_URL
} from "../constants/urls";

export class AuthServices {
  /**
   * ## Auth signup
   * @param {FormData} data
   */
  static signup(data) {
    var config = {
      method: "post",
      url: API_SIGNUP_URL,
      data: data
    };
    return apiFetech(config);
  }

  /**
   * ## Auth signIn
   * @param {FormData} data
   */
  static signin(data) {
    var config = {
      method: "post",
      url: API_SIGNIN_URL,
      data: data
    };
    return apiFetech(config);
  }

  /**
   * ## Get Customer Profile
   * @param {FormData} data
   */
  static getProfile(userToken) {
    var config = {
      method: "get",
      url: API_PROFILE_URL,
      headers: {
        Authorization: `Bearer ${userToken}`
      }
    };
    return apiFetech(config);
  }

/**
 * ## Logout
 * @param {String} token 
 * @returns 
 */
  static signOut ({token}) {
    var config = {
      method: "post",
      url: "customer/logout",
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    return apiFetech(config);
  }

  // ** updateProfile
  static updateProfile ({formData}){
    var config = {
      method: "post",
      url: "customer/edit_profile",
      data:formData
    };
    return apiFetech(config);
  }

  // ** Forget Password
  static forgetPassword({email}) {
   const formData = new FormData();
   formData.append('email', `${email}`);
    var config = {
      method: "post",
      url: "forget_password",
      data:formData
    };
    return apiFetech(config);
  }

  // ** Reset Password
  static resetPassword({formData}) {
     var config = {
       method: "post",
       url: "reset_password",
       data:formData
     };
     return apiFetech(config);
  }

  // ** Send Message
  static sendMessage ({token="",formData}){
    var config = {
      method: "post",
      url: "tickets/store",
      headers: {
        Authorization: `Bearer ${token}`
      },
      data:formData
    };
    return apiFetech(config);
  }

  static removeAccount({token=""}){
    var config = {
      method: "delete",
      url: "customer/delete-account",
      headers: {
        Authorization: `Bearer ${token}`
      },
    };
    return apiFetech(config);
  }
}
